import { Link } from "react-router-dom";
import { Brand } from "@/components/Brand";
import { SocialLinks } from "@/components/SocialLinks";

export function Footer() {
  return (
    <footer className="border-t border-border bg-card/30 py-16">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="mb-4">
              <Brand size="md" showTagline={true} />
            </div>
            <p className="text-sm text-muted-foreground max-w-sm leading-relaxed mb-6">
              The global reference platform for humanoid robots. Structured, neutral, 
              continuously updated data for researchers, investors, and builders.
            </p>
            <SocialLinks iconSize="md" />
          </div>

          <div>
            <p className="font-mono text-xs uppercase tracking-widest text-muted-foreground mb-4">Platform</p>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/robots" className="text-muted-foreground hover:text-foreground transition-colors">Robots</Link></li>
              <li><Link to="/companies" className="text-muted-foreground hover:text-foreground transition-colors">Companies</Link></li>
              <li><Link to="/compare" className="text-muted-foreground hover:text-foreground transition-colors">Compare</Link></li>
              <li><Link to="/ecosystem" className="text-muted-foreground hover:text-foreground transition-colors">Ecosystem</Link></li>
            </ul>
          </div>

          <div>
            <p className="font-mono text-xs uppercase tracking-widest text-muted-foreground mb-4">Resources</p>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/contribute" className="text-muted-foreground hover:text-foreground transition-colors">Contribute</Link></li>
              <li><Link to="/newsletter" className="text-muted-foreground hover:text-foreground transition-colors">Newsletter</Link></li>
              <li><a href="#" className="text-muted-foreground hover:text-foreground transition-colors">API Access</a></li>
              <li><a href="#" className="text-muted-foreground hover:text-foreground transition-colors">Contact</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-border flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-muted-foreground font-mono">
            © {new Date().getFullYear()} Lineroid. Data sourced from public records.
          </p>
          <div className="flex items-center gap-6 text-xs text-muted-foreground">
            <a href="#" className="hover:text-foreground transition-colors">Privacy</a>
            <a href="#" className="hover:text-foreground transition-colors">Terms</a>
            <a href="#" className="hover:text-foreground transition-colors">Data Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
